import client from '../client'

export async function cancelDirectOfferBySeller({ directOfferId }) {
  return client(
    `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/CancelDirectOfferBySeller`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ directOfferId }),
    },
  )
}
